<template>
  <Tracker />
</template>

<script>
import Tracker from '@/components/Tracker.vue'
export default {
  name: 'App',
  components: {
    Tracker
  }
}
</script>

<style>
body{
  background:#0a192f !important;
  color:white;
}
</style>
